import React from 'react';
import { KIND } from '../../constants';
import { useProgress } from '../hooks/useProgress';
import { timelineStopKeys } from '../state/derive';
import { useWeddingDay } from '../state/useWeddingDay';

const e = React.createElement;

const Arrow = ({ dir }) =>
  e(
    'svg',
    {
      width: 16,
      height: 16,
      viewBox: '0 0 24 24',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 2.2,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    e('path', { d: dir === 'prev' ? 'M15 18l-6-6 6-6' : 'M9 6l6 6-6 6' })
  );

// One bar shape across every section: previous, the section's own status, next.
const BottomBar = () => {
  const { section, prevKey, nextKey, goTo, phase, setPhase, wantsInterview,
    askInterview } =
    useWeddingDay();
  const { steps, positionLabel } = useProgress();
  if (!section) return null;

  // The timeline is one step with two stops inside it. Next walks to the
  // timings before it leaves the section, and Prev walks back the same way,
  // so neither phase can be stepped over.
  const kind = section.kind || section.key;
  const onTimeline = kind === KIND.TIMELINE;
  // The stops inside the timeline, in order. Answering the interview
  // question never moves the couple off it, and only a yes puts the sittings
  // in the walk.
  const stops = timelineStopKeys({ wantsInterview, askInterview });
  const found = onTimeline ? stops.indexOf(phase) : -1;
  // Saying no to the interviews takes that stop out from under the couple
  // while they are standing on it. That reads as past the last stop: next
  // leaves the section, and back steps to the last stop still there.
  const at = found >= 0 ? found : stops.length;
  const goNext = () => {
    if (onTimeline && at < stops.length - 1) return setPhase(stops[at + 1]);
    if (nextKey) goTo(nextKey);
  };
  const goPrev = () => {
    if (onTimeline && at > 0) {
      return setPhase(stops[Math.min(at, stops.length) - 1]);
    }
    if (prevKey) goTo(prevKey);
  };
  const canNext = !!nextKey || (onTimeline && at < stops.length - 1);
  const canPrev = !!prevKey || (onTimeline && at > 0);

  const current = steps.find((s) => s.current);
  const status = current
    ? `${positionLabel}${current.optional ? ' · Optional' : ''}`
    : positionLabel;

  return e('div', { className: 'wd-bar' }, [
    e(
      'button',
      {
        key: 'prev',
        type: 'button',
        className: 'wd-nav',
        disabled: !canPrev,
        onClick: goPrev,
        'aria-label': 'Previous section',
      },
      e(Arrow, { dir: 'prev' })
    ),
    e('div', { className: 'wd-bar-status', key: 'status' }, status),
    e(
      'button',
      {
        key: 'next',
        type: 'button',
        className: 'wd-nav',
        disabled: !canNext,
        onClick: goNext,
        'aria-label': 'Next section',
      },
      e(Arrow, { dir: 'next' })
    ),
  ]);
};

export default BottomBar;
